import { useMonitor } from '../use-monitor';

export function useMonitorMasterIssuesList() {
  return useMonitor('master-issues-load');
}
